<button
  class="button button__{{ color }} button--{{ fill }} button--padding-{{ padding }} button--{{ size }} button--{{ iconPosition }}"
  [type]="type"
  [disabled]="disabled"
  [ngClass]="{ 'button--disabled': disabled }"
>
  <ng-container *ngIf="icon">
    <img
      class="button__icon"
      alt="Button icon"
      mfpLazyImage
      [lazySrc]="icon"
      [ngClass]="{ 'button__icon--no-margin': !label }"
    >
  </ng-container>
  <span>{{ label }}</span>
</button>
